module.exports = __webpack_public_path__ + "img/indd.78df7a9f.svg";